import React from 'react';
import {BrowserRouter as Router,Routes,Route} from 'react-router-dom';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import './App.css';
import './components/EmojiBox.css';

function App() {
  return (
    <Router>
      <div className="morphing-background">
        <div className="gradient1"></div>
        <div className="gradient2"></div>
      </div>
      <div className="content-container">
        <div className="min-h-screen flex flex-col">
          <div className="flex-1 flex items-center justify-center">
            <main className="w-full max-w-4xl px-4 flex flex-col items-center">
              <Routes>
                <Route path="/" element={<HomePage />} />
              </Routes>
            </main>
          </div>
          <Footer />
        </div>
      </div>
    </Router>
  );
}

export default App;